
import Category from "@/types/Category";
import {computed, defineComponent, PropType} from "vue";
import Multiselect from "../General/Multiselect.vue";

export default defineComponent({
  props: {
    categories: {
      type: Array as PropType<Category[]>,
      required: true,
    },
    modelValue: {
      type: Array as PropType<number[]>,
      required: true,
    },
    addMainCategories: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const value = computed({
      get: () => props.modelValue,
      set: (v) => {
        context.emit("update:modelValue", v);
      },
    });

    const options = async (query) => {
      const categories = JSON.parse(JSON.stringify(props.categories));
      return categories?.map((main: Category) => {
        if (!props.addMainCategories) {
          return main;
        }

        main.children?.unshift({
          id: main.id,
          label: main.label,
          parent: 0,
          type: "category",
        });
        // search the categories by label
        if (query) {
          main.children = main.children?.filter((child) => {
            return child.label.toLowerCase().includes(query.toLowerCase());
          });
        }
        return main;
      });
    }
    const getOptions = async (query) => {
      return new Promise((resolve, reject) => {
        resolve(options(query));
      });
    };

    return {
      value,
      getOptions,
    };
  },
  components: { Multiselect },
});
